//vendors
import * as THREE from 'three';
import gsap from 'gsap';

//sceneEntities
import Lights from '../stage/Lights';
import Tube from '../stage/Tube';
import Platforms from '../stage/Platforms';
import Ball from '../stage/Ball';

//utils
import Tools from "../utils/Tools";
import AssetsManager from '../components/AssetsManager';
import GameManager from '../components/GameManager';
import { GameConfig } from '../utils/GameConfig';
import { DEG2RAD } from 'three/src/math/MathUtils';
import { MeshBasicMaterial } from 'three';
import tools from 'tools';

export default class StageManager extends THREE.Object3D {
    constructor() {
        super();

        // Ball of the game
        this._ball = null;

        // Platform group of the game
        this._platformGroup = null;
    }

    /** 
     * Public 
    */

    setup() {



        // Setup all the entities and call the build method on each



        let lights = new Lights();        
        let tube = new Tube();        
        let ball = new Ball();        
        let platforms = new Platforms();        
       

        this.sceneEntities = {};
        this.sceneEntities.lights = lights;
        this.sceneEntities.tube = tube;
        this.sceneEntities.ball = ball;
        this.sceneEntities.platforms = platforms;


        GameManager.ball = this.sceneEntities.ball;
        GameManager.platforms = this.sceneEntities.platforms;
        GameManager.tube = this.sceneEntities.tube;

        //console.log(this.sceneEntities.platforms);

        for (let model in this.sceneEntities) {
            this.sceneEntities[model].build(this._models);
            GameManager.scene.add(this.sceneEntities[model]);
        }



        console.log(">>>", GameManager.camera)

        this._wall = this.wall();
        this._wall.position.z = 20;
        this._wall.position.y = 0;
        this._wall.rotation.z = DEG2RAD * 180;
        this._wall.rotation.x = DEG2RAD * 45;
        GameManager.scene.add(this._wall);


    }


    wall() {

        this.object = new THREE.Object3D();

        let material = new MeshBasicMaterial();
        material.color = new THREE.Color(0xffffff);

        let particle = new THREE.Mesh(new THREE.PlaneGeometry(2, 2), material);
        particle.material.map = AssetsManager.texturesThree.ParticleCircle;
        particle.material.depthWrite = false;
        particle.material.opacity = .2;
        particle.material.side = THREE.DoubleSide;
        // particle.material.blending = THREE.AdditiveBlending;
        particle.rotation.y = 180 * DEG2RAD;
        particle.scale.set(.5, .5, .5);
        particle.material.transparent = true;


        let arr = [];
        let maxHeight = 32;

        for (var i = 0; i < 70; i++) {
            let scale = Math.random() * .4;
            let posx = -6 + 12 * Math.random()
            arr.push({
                position: { x: posx, y: Math.random() * maxHeight, z: 0 },
                rotation: { x: 0, y: 0, z: 0 },
                scale: { x: scale, y: scale, z: scale },
                randomx: tools.range(-.004, .004),
                initx: posx
            });
        }


        var mat = particle.material;
        var geo = particle.geometry;
        geo.computeVertexNormals();



        var _dummy = new THREE.Object3D();
        var paricules = new THREE.InstancedMesh(geo, mat, arr.length);
        // paricules.material.blending = THREE.AdditiveBlending;
        paricules.instanceMatrix.setUsage(THREE.DynamicDrawUsage);

        this.object.add(paricules);

        var decaly = 0;

        this.object.update = () => {
            decaly += .012;
            var _id = 0;
            for (var i = 0; i < arr.length; i++) {
                let posy = arr[i].position.y + decaly;

                if (posy > maxHeight) {
                    arr[i].position.y -= maxHeight * .9;
                    arr[i].position.x = arr[i].initx;
                }
                arr[i].position.x += arr[i].randomx;
                _dummy.position.set(arr[i].position.x, posy, arr[i].position.z);
                _dummy.rotation.set(arr[i].rotation.x * DEG2RAD, arr[i].rotation.y * DEG2RAD, arr[i].rotation.z * DEG2RAD);
                arr[i].scale && _dummy.scale.set(arr[i].scale.x, arr[i].scale.y, arr[i].scale.z);
                _dummy.updateMatrix();
                paricules.setMatrixAt(_id, _dummy.matrix);
                _id++;

            }

            paricules.instanceMatrix.needsUpdate = true;

        }

        return this.object;

    }

    update() {

        for (let entity in this.sceneEntities) {
            this.sceneEntities[entity].update();
        }

        this._wall && this._wall.update();

    }

    restart() {

    }
}